/* ── Default palette ──────────────────────────────────────────
 * Presentational fallback so tags without an explicit color still
 * render a stable, distinct hue. Consumers normally pass real colors.
 */

// The shared Coval Accessible Data Palette (chart-tokens.css), referenced as
// CSS vars so the fallback hues match the app's chart/series identity colors
// and stay theme-aware. Order mirrors seriesPalette's SERIES_RAMPS.
const DEFAULT_TAG_PALETTE = [
  "var(--coval-chart-series-1)",
  "var(--coval-chart-series-2)",
  "var(--coval-chart-series-3)",
  "var(--coval-chart-series-4)",
  "var(--coval-chart-series-5)",
  "var(--coval-chart-series-6)",
  "var(--coval-chart-series-7)",
  "var(--coval-chart-series-8)",
]

function fallbackColor(value: string): string {
  let hash = 0
  for (let i = 0; i < value.length; i++) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0
  }
  const index = Math.abs(hash) % DEFAULT_TAG_PALETTE.length
  return DEFAULT_TAG_PALETTE[index]
}

/** A tag's accent color, or a stable palette hue when it has none. */
export function resolveColor(option: {
  value: string
  color?: string
}): string {
  return option.color || fallbackColor(option.value)
}
